import React from "react";
import BaseView from "../common/BaseView";
import { columns } from "./config";
import { getActiveTransactions } from "../../../Api";
import withData from "../../Data/withData";

function View(props: any) {
  return (
    <BaseView
      columns={columns}
      title="Active Transactions"
      subtitle="These are active companies that have progressed into final underwriting and contract creation."
      {...props}
    ></BaseView>
  );
}

export default withData(View, getActiveTransactions);
